/* mk-pincode-check (MOO-312).
 * Enter a pincode, see "Reaches you in X to Y days": making window (data
 * attributes, default 4 to 8) plus the Delhivery transit estimate from the
 * shipping proxy. Included from snippets/mk-pincode-check.liquid; may load
 * twice on a page (product + cart drawer), so everything is guarded behind
 * window.mkPin.
 */
(function () {
  if (window.mkPin) return;

  var PIN_KEY = 'mkPin';
  var CACHE_KEY = 'mkPinData';
  var CACHE_TTL = 24 * 60 * 60 * 1000; // re-check a pin once a day
  var PIN_RE = /^[1-9][0-9]{5}$/;

  function store(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function load(key) {
    try { return JSON.parse(localStorage.getItem(key)); } catch (e) { return null; }
  }

  function fetchPin(proxy, pin) {
    proxy = (proxy || '').replace(/\/+$/, ''); // tolerate a pasted trailing slash
    var cache = load(CACHE_KEY);
    if (cache && cache.pin === pin && Date.now() - cache.t < CACHE_TTL) {
      return Promise.resolve(cache);
    }
    var svc = fetch(proxy + '/serviceability?pin=' + pin).then(function (r) { return r.json(); });
    var eta = fetch(proxy + '/eta?pin=' + pin).then(function (r) { return r.json(); }).catch(function () { return {}; });
    return Promise.all([svc, eta]).then(function (res) {
      // ok:false means the proxy or Delhivery errored, NOT that the pin is
      // unserviceable; only a true ok carries a real serviceability verdict.
      if (!res[0] || res[0].ok !== true) throw new Error('proxy error');
      var data = {
        pin: pin,
        t: Date.now(),
        serviceable: !!res[0].serviceable,
        district: res[0].district || null,
        tat: (res[1] && res[1].ok === true && typeof res[1].tat_days === 'number') ? res[1].tat_days : null,
      };
      store(CACHE_KEY, data);
      return data;
    }).catch(function () {
      // Proxy unreachable or errored: promise the making window alone, and
      // backdate the cache entry so it goes stale in ~10 minutes and retries.
      var data = { pin: pin, t: Date.now() - CACHE_TTL + 10 * 60 * 1000, fallback: true };
      store(CACHE_KEY, data);
      return data;
    });
  }

  function widgets() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mk-pin]'));
  }

  function renderAll() {
    var pin = load(PIN_KEY);
    var cache = load(CACHE_KEY);
    widgets().forEach(function (el) {
      render(el, pin, cache && cache.pin === pin ? cache : null);
    });
  }

  // Lead text, then the day range in bold so the answer is what the eye
  // lands on. Built with text nodes: the district name comes from the proxy.
  function setLine(line, lead, days, tail) {
    var strong = document.createElement('strong');
    strong.textContent = days;
    line.textContent = lead;
    line.appendChild(strong);
    line.appendChild(document.createTextNode(tail));
  }

  function render(el, pin, data) {
    el.setAttribute('data-mk-pin-ready', '');
    var line = el.querySelector('[data-mk-pin-text]');
    var form = el.querySelector('[data-mk-pin-form]');
    var change = el.querySelector('[data-mk-pin-change]');
    var makeMin = parseInt(el.getAttribute('data-make-min'), 10) || 4;
    var makeMax = parseInt(el.getAttribute('data-make-max'), 10) || 8;
    if (makeMax < makeMin) makeMax = makeMin; // guard inverted theme settings

    el.classList.remove('mk-pin--ok', 'mk-pin--no', 'mk-pin--invalid');

    if (pin && data) {
      form.hidden = true;
      change.hidden = false;
      var place = data.district || pin;
      if (data.fallback) {
        el.classList.add('mk-pin--ok');
        setLine(line, 'Reaches you in ', makeMin + ' to ' + makeMax + ' days', '.');
      } else if (data.serviceable && data.tat != null) {
        el.classList.add('mk-pin--ok');
        setLine(line, 'Reaches ' + place + ' in ', (makeMin + data.tat) + ' to ' + (makeMax + data.tat) + ' days', '.');
      } else if (data.serviceable) {
        el.classList.add('mk-pin--ok');
        line.textContent = 'Good news, I ship to ' + place + '!';
      } else {
        el.classList.add('mk-pin--no');
        line.textContent = 'My courier does not reach ' + pin + ' yet. DM @moonkiln on Instagram and I will sort something out.';
      }
    } else {
      form.hidden = false;
      change.hidden = true;
      line.textContent = 'See how soon it can reach you:';
    }
  }

  function check(el, raw) {
    var pin = (raw || '').replace(/\D/g, '');
    var proxy = el.getAttribute('data-proxy');
    if (!proxy) return; // proxy URL not configured yet (theme setting)
    if (!PIN_RE.test(pin)) { el.classList.add('mk-pin--invalid'); return; }
    var btn = el.querySelector('[data-mk-pin-btn]');
    btn.disabled = true;
    // fetchPin never rejects. Render straight from the resolved data so the
    // answer shows even when localStorage is blocked (private browsing).
    fetchPin(proxy, pin).then(function (data) {
      store(PIN_KEY, pin);
      btn.disabled = false;
      widgets().forEach(function (w) { render(w, pin, data); });
      // PostHog action "Pincode checked" (MOO-411). First three digits only:
      // enough for a region breakdown, never the full pincode.
      if (window.posthog && window.posthog.capture) {
        window.posthog.capture('pincode checked', {
          context: el.getAttribute('data-context') || 'product',
          pin_prefix: pin.slice(0, 3),
          serviceable: data.serviceable === true,
          tat_days: typeof data.tat === 'number' ? data.tat : null,
          district: data.district || null
        });
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var el = e.target.closest && e.target.closest('[data-mk-pin]');
    if (!el || !e.target.hasAttribute('data-mk-pin-form')) return;
    e.preventDefault();
    check(el, el.querySelector('[data-mk-pin-input]').value);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-mk-pin-change]');
    if (!btn) return;
    try { localStorage.removeItem(PIN_KEY); } catch (err) {}
    renderAll();
    var el = btn.closest('[data-mk-pin]');
    var input = el && el.querySelector('[data-mk-pin-input]');
    if (input) input.focus();
  });

  // The cart drawer re-renders its contents on cart changes; re-hydrate any
  // freshly inserted widget instances. Only fire when an unhydrated instance
  // appears, so our own DOM writes do not retrigger the observer.
  var mo = new MutationObserver(function () {
    if (document.querySelector('[data-mk-pin]:not([data-mk-pin-ready])')) renderAll();
  });

  function init() {
    renderAll();
    // Saved pin with a stale or missing cache entry: re-fetch so returning
    // visitors keep their personalised estimate instead of the empty prompt.
    var pin = load(PIN_KEY);
    var cache = load(CACHE_KEY);
    if (pin && !(cache && cache.pin === pin && Date.now() - cache.t < CACHE_TTL)) {
      var first = widgets()[0];
      var proxy = first && first.getAttribute('data-proxy');
      if (proxy) fetchPin(proxy, pin).then(function () { renderAll(); });
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) mo.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.mkPin = { refresh: renderAll };
})();
